<div class="steps-bar">
  <div
    *ngFor="let label of steps; let i = index"
    class="step"
    [class.active]="getStepState(i + 1) === 'active'"
    [class.done]="getStepState(i + 1) === 'done'"
    [style.border-left]="i === 0 ? '' : 'none'"
    [style.border-radius]="i === 0 ? '6px 0 0 6px' : i === steps.length - 1 ? '0 6px 6px 0' : '0'"
  >
    <div class="step-num">
      <svg *ngIf="getStepState(i + 1) === 'done'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="12" height="12">
        <polyline points="20 6 9 17 4 12"/>
      </svg>
      <span *ngIf="getStepState(i + 1) !== 'done'">{{ i + 1 }}</span>
    </div>
    <span class="step-label">{{ label }}</span>
  </div>
</div>
